import { Box, Stack } from "@mui/material";
import { LicensingForm as LicensingFormType } from "../../../types/forms/capture";
import { Licensing } from "../../../types/model/licensing";
import LicensingForm from "./LicensingForm";

interface CaptureLicensingProps {
  licensingData?: Licensing | null;
  canEdit: boolean;
  onCreate: (values: LicensingFormType) => Promise<void>;
  onUpdate: (licensingId: number, values: LicensingFormType) => Promise<void>;
}

export default function CaptureLicensing({
  licensingData,
  canEdit,
  onCreate,
  onUpdate,
}: Readonly<CaptureLicensingProps>) {
  const isExisting = !!licensingData;

  return (
    <Stack spacing={2}>
      <Box>
        <LicensingForm
          licensingData={licensingData}
          canEdit={canEdit}
          onSubmit={async (values) => {
            if (isExisting && licensingData?.id) {
              await onUpdate(licensingData.id, values);
            } else {
              await onCreate(values);
            }
          }}
        />
      </Box>
    </Stack>
  );
}
